import { render, staticRenderFns } from "./ContractTimelineRegulation.vue?vue&type=template&id=5863e331&"
import script from "./ContractTimelineRegulation.vue?vue&type=script&lang=js&"
export * from "./ContractTimelineRegulation.vue?vue&type=script&lang=js&"
import style0 from "./ContractTimelineRegulation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports